// extracted by mini-css-extract-plugin
module.exports = {"main-yellow":"#fcd406","linkItem":"LinkItem-module__linkItem___2lgHk","heading":"LinkItem-module__heading___18cT4","link":"LinkItem-module__link___2kXjs"};